import { deleteBankAccount } from '@/services/BankAccounts/BankAccount/Delete'

import { notifyError, notifyMessage } from '@/services/notify'

import _get from 'lodash/get'

export async function eraseLinkedAccount() {
  const bankAccountID = _get(this, ['account', 'bankAccountID'], '')
  const accountName = _get(this, ['account', 'name'], '')

  const { successful, message } = await deleteBankAccount({
    bankAccountID
  })
  if (!successful) {
    console.error(message)
    notifyError(message)
    return
  }

  notifyMessage(`${accountName} was successfully deleted.`)
  this.$router.push('/bankAccounts')
}
